import { CashiersBinding } from './CashiersBinding'
import { ReceiptsServiceFrame } from './ReceiptsServiceFrame'

/** Вкладка «Коды по источникам» раздела «Коды кассиров»: прежний вход «кассир источника + PIN» (до RP-CU4), источник, его кассиры, код и настройки РМК. */
export function CashiersWindowBinding() {
  return <ReceiptsServiceFrame><CashiersBinding /></ReceiptsServiceFrame>
}
